<!--
 * @Description: 违约责任
 * @Autor: txp
 * @Date: 2021-04-07 10:54:47
-->
<template>
    <div class="basicformation">
        <div class="title">{{names}}</div>
        <div class="content">
            <el-row type="flex" class="row-bg">
                <el-col class="flex" :span="24">
                    <div class="grid-content"></div>
                    <div class="bg-purple">
                        <div v-if="dataLists" v-html="dataLists[0].liabilityForBreach"></div>
                        <div v-else>暂无</div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name:'basicformation',
    props:['dataLists','names'],
    created(){
        // console.log(this.haha())
    },
    methods:{
        haha(){
            // console.log(this.dataLists)
        }
    },
}
</script>
<style lang="scss" scoped>
    .basicformation{
        margin: 20px 0px;
        border-bottom: 1px solid $color-primary;
        .title{
            font-size: 18px;
            font-weight: 600;
            border-left: 9px solid $color-primary;
            padding-left: 9px;
            height: 18px;
            line-height: 18px;
        }
        .content{
            padding: 20px;
            /deep/ .el-row {
                .el-col{
                    border-radius: 4px;
                    line-height: 30px;
                    margin-top: 10px;
                }
                .grid-content{
                    width: 130px;
                    text-align: right;
                    padding-right: 10px;
                    box-sizing: border-box;
                    font-size: 13px;
                    color: #666666;
                }
                .bg-purple{
                    font-size: 13px;
                    color: #666666;
                    background: #eee;
                    min-height: 30px;
                    flex: 1;
                    padding:10px;
                    // line-height: 40px;
                }
            }
        }
    }
</style>
